import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    const emails = this.element.value;
    // Pre-filling email addresses manually due to Safari's limitation and security concerns.
    this.element.value = emails;
  }
}
